/**
 * Mapeamento de eBooks com seus PDFs correspondentes
 * 
 * Estrutura:
 * - id: ID único do produto (deve ser igual ao ShopPage.js)
 * - title: Título do eBook
 * - pdfPath: Caminho para o PDF (relativo à pasta public/ebbokspdfs)
 * - pdfFileName: Nome do arquivo para download
 * - category: Categoria
 * - fileSize: Tamanho do arquivo em MB (para referência)
 */

export const EBOOK_PDF_MAPPING = {
  'colecao-completa-13-1': {
    id: 'colecao-completa-13-1',
    title: 'COLEÇÃO COMPLETA: 13 EM 1',
    pdfPath: '/ebbokspdfs/COLEÇÃO COMPLETA - 13 em 1 - pdf.pdf',
    pdfFileName: 'Colecao-Completa-13-em-1.pdf',
    category: 'Coleções',
    fileSize: 25.5,
    description: 'Todos os 13 eBooks em um único arquivo com 500+ cifras',
  },
  'cifras-advento': {
    id: 'cifras-advento',
    title: 'Cifras de Músicas - Advento',
    pdfPath: '/ebbokspdfs/1. ADVENTO - pdf.pdf',
    pdfFileName: 'Cifras-Advento.pdf',
    category: 'Litúrgico',
    fileSize: 2.1,
    description: 'Cifras especiais para o período do Advento',
  },
  'cifras-natal': {
    id: 'cifras-natal',
    title: 'Cifras de Músicas - Natal',
    pdfPath: '/ebbokspdfs/2. NATAL - pdf.pdf',
    pdfFileName: 'Cifras-Natal.pdf',
    category: 'Litúrgico',
    fileSize: 2.3,
    description: 'Cifras natalinas e cantos de Natal para viola',
  },
  'cifras-quaresma': {
    id: 'cifras-quaresma',
    title: 'Cifras de Músicas - Quaresma',
    pdfPath: '/ebbokspdfs/3. QUARESMA - pdf.pdf',
    pdfFileName: 'Cifras-Quaresma.pdf',
    category: 'Litúrgico',
    fileSize: 2.0,
    description: 'Cifras especiais para o período da Quaresma',
  },
  
  'cifras-tempo-comum': {
    id: 'cifras-tempo-comum',
    title: 'Cifras de Músicas - Tempo Comum',
    pdfPath: '/ebbokspdfs/5. TEMPO COMUM - pdf.pdf',
    pdfFileName: 'Cifras-Tempo-Comum.pdf',
    category: 'Litúrgico',
    fileSize: 3.5,
    description: 'Músicas para o tempo ordinário da liturgia católica',
  },
  'cifras-partes-fixas': {
    id: 'cifras-partes-fixas',
    title: 'Cifras de Músicas - Partes Fixas',
    pdfPath: '/ebbokspdfs/6. PARTES FIXAS - pdf.pdf',
    pdfFileName: 'Cifras-Partes-Fixas.pdf',
    category: 'Litúrgico',
    fileSize: 1.8,
    description: 'Partes fixas da missa e liturgia em cifras',
  },
  'cifras-adoracao': {
    id: 'cifras-adoracao',
    title: 'Cifras de Músicas - Adoração',
    pdfPath: '/ebbokspdfs/8. ADORAÇÃO - pdf.pdf',
    pdfFileName: 'Cifras-Adoracao.pdf',
    category: 'Adoração',
    fileSize: 2.4,
    description: 'Cifras de cantos de adoração e louvor para viola',
  },
  'cifras-marianas': {
    id: 'cifras-marianas',
    title: 'Cifras de Músicas - Marianas',
    pdfPath: '/ebbokspdfs/7. MARIANAS - pdf.pdf',
    pdfFileName: 'Cifras-Marianas.pdf',
    category: 'Marianas',
    fileSize: 2.1,
    description: 'Cifras dedicadas às músicas marianas',
  },
  'cifras-mais-conhecidas': {
    id: 'cifras-mais-conhecidas',
    title: 'Cifras de Músicas - Mais Conhecidas',
    pdfPath: '/ebbokspdfs/10. MAIS CONHECIDAS - pdf.pdf',
    pdfFileName: 'Cifras-Mais-Conhecidas.pdf',
    category: 'Popular',
    fileSize: 2.3,
    description: 'Seleção das músicas mais conhecidas e populares',
  },
  'cifras-que-nos-marcaram': {
    id: 'cifras-que-nos-marcaram',
    title: 'Cifras de Músicas que nos Marcaram',
    pdfPath: '/ebbokspdfs/11. MARCANTES - pdf.pdf',
    pdfFileName: 'Cifras-Que-Nos-Marcaram.pdf',
    category: 'Popular',
    fileSize: 2.7,
    description: 'Coletânea de músicas que nos marcaram',
  },
  'cifras-grupos-oracao': {
    id: 'cifras-grupos-oracao',
    title: 'Cifras de Músicas - Grupos de Oração',
    pdfPath: '/ebbokspdfs/9. GRUPO DE ORAÇÃO - pdf.pdf',
    pdfFileName: 'Cifras-Grupos-Oracao.pdf',
    category: 'Comunidade',
    fileSize: 2.2,
    description: 'Músicas perfeitas para grupos de oração',
  },
  'cifras-infantis': {
    id: 'cifras-infantis',
    title: 'Cifras de Músicas Infantis',
    pdfPath: '/ebbokspdfs/12. INFANTIS - pdf.pdf',
    pdfFileName: 'Cifras-Infantis.pdf',
    category: 'Infantil',
    fileSize: 1.9,
    description: 'Coletânea de músicas infantis com cifras',
  },
  'tablaturas': {
    id: 'tablaturas',
    title: 'Tablaturas católicas para Fingerstyle',
    pdfPath: '/ebbokspdfs/FINGERSTYLE.pdf',
    pdfFileName: 'Cifras-Fingerstyle.pdf',
    category: 'Técnica',
    fileSize: 2.5,
    description: 'Técnica especial de fingerstyle para viola',
  },
};

/**
 * Obter informações de PDF de um eBook
 * @param {string} ebookId - ID do eBook
 * @returns {Object|null} - Objeto com informações do PDF ou null
 */
export function getEbookPdfInfo(ebookId) {
  return EBOOK_PDF_MAPPING[ebookId] || null;
}

/**
 * Obter todos os PDFs mapeados
 * @returns {Array} - Array com todos os eBooks mapeados
 */
export function getAllEbookPdfs() {
  return Object.values(EBOOK_PDF_MAPPING);
}

/**
 * Verificar se um eBook tem PDF disponível
 * @param {string} ebookId - ID do eBook
 * @returns {boolean}
 */
export function hasPdf(ebookId) {
  return ebookId in EBOOK_PDF_MAPPING;
}

/**
 * Obter caminho do PDF por ID (com URL encoding para nomes com espaços/acentos)
 * @param {string} ebookId - ID do eBook
 * @returns {string|null}
 */
export function getPdfPath(ebookId) {
  const pdfInfo = EBOOK_PDF_MAPPING[ebookId];
  if (!pdfInfo) return null;
  
  // Separar diretório e nome do arquivo
  const parts = pdfInfo.pdfPath.split('/');
  const fileName = parts[parts.length - 1];
  const dir = parts.slice(0, -1).join('/');
  
  // Codificar o nome do arquivo para URL
  const encodedFileName = encodeURIComponent(fileName);
  
  return `${dir}/${encodedFileName}`;
}

/**
 * Obter nome do arquivo para download
 * @param {string} ebookId - ID do eBook
 * @returns {string|null}
 */
export function getPdfFileName(ebookId) {
  const pdfInfo = EBOOK_PDF_MAPPING[ebookId];
  return pdfInfo ? pdfInfo.pdfFileName : null;
}

export default EBOOK_PDF_MAPPING;
